import { useSearchParams } from "react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/lib/auth-context";
import { InviteTeamDialog } from "./_components/invite-team-dialog";
import { TeamTab } from "./_components/team-tab";
import { PartnerContactsTab } from "./_components/partner-contacts-tab";

// /admin/users — unified user manager. Two populations:
//   • Team          internal Bookboost staff + pending invites (role + access)
//   • Partner users external partner contacts across every partner
// Gated on users.read upstream (sidebar + this page); mutations need
// users.manage and fail closed server-side.
export function UsersPage() {
  const session = useAuth().session;
  const canManage = !!session?.permissions.includes("users.manage");

  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "partners" ? "partners" : "team";

  return (
    <div>
      <header className="mb-7 flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">
            Users
          </h1>
          <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
            Manage who can access Colab — invite teammates, set their role and
            permissions, control account access, and oversee partner contacts.
          </p>
        </div>
        {canManage && tab === "team" && <InviteTeamDialog />}
      </header>

      <Tabs
        value={tab}
        onValueChange={(v) => {
          const next = new URLSearchParams(params);
          next.set("tab", v);
          setParams(next, { replace: true });
        }}
      >
        <TabsList className="mb-5">
          <TabsTrigger value="team">Team</TabsTrigger>
          <TabsTrigger value="partners">Partner users</TabsTrigger>
        </TabsList>
        <TabsContent value="team">
          <TeamTab />
        </TabsContent>
        <TabsContent value="partners">
          <PartnerContactsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
